import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import UnitPage from "../../components/Units/UnitList";


const UnitListPage = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        
        <div className="d-flex justify-content-between"><h5>Units  </h5><Breadcrumb title="Units" /></div>

        {/* UsersListLayer */}
        <UnitPage />



    </>
  );
};

export default UnitListPage; 
